export const distanceBetweenElements = (
  fromElement,
  toElement,
  containerElement,
) => {
  const fromPos = fromElement?.getBoundingClientRect();
  const toPos = toElement?.getBoundingClientRect();
  const containerPos = containerElement?.getBoundingClientRect();

  if (!fromPos || !toPos || !containerPos) return 0;

  const elementMiddle = toPos.left + toPos.width / 2;
  const containerWidth = containerPos.width;

  if (!containerWidth) return null;
  const elementContainerRatio = elementMiddle / containerWidth;

  let screenModifier = 0;
  switch (true) {
    case containerWidth < 500 || toPos.right < 0 || toPos.left > containerWidth:
      screenModifier = 0.5;
      break;
    case containerWidth < 800 && elementContainerRatio > 0.6:
      screenModifier = 0.6;
      break;
    case containerWidth < 800 && elementContainerRatio < 0.4:
      screenModifier = 0.4;
      break;
    case elementContainerRatio > 0.7:
      screenModifier = 0.7;
      break;
    case elementContainerRatio < 0.3:
      screenModifier = 0.3;
      break;
    default:
      return null;
  }

  const containerAdjustment = containerWidth * screenModifier;
  return elementMiddle - fromPos.left - containerAdjustment;
};

export const getHotelSubNavScrollDistance = () => {
  const firstElement = document.getElementById('hotelInfoNavEl--first');
  const activeElement = document.getElementById('hotelInfoNavEl--active');
  const container = firstElement?.parentElement;
  return distanceBetweenElements(firstElement, activeElement, container) || 0;
};

export const setHotelSubNavScrollDistance = (distance) => {
  const el = document.getElementById('gw-horizontal-scroll');
  el.scrollLeft = distance;
};

export const scrollToSectionStart = () => {
  const element = document.getElementById('gw-hotel-info-top');
  const elementTop = element.getBoundingClientRect().top;
  const elementDistance = elementTop + window.scrollY;
  window.scrollTo({ top: elementDistance, behavior: 'smooth' });
};
